import { Pagination } from 'antd';
import styled from 'styled-components';

export default styled(Pagination)`
	// Add your styles here
`;
